if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      // Agregado: bandera para saber si ya se ha interactuado con la selección
      this.hasUserChanged = false;
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();            // [agrupación por imagen] inactivo si no hay data-set-name
      this.applyVariantFilters();    // [filtrado por variante]
      // Al cargar la ficha, se actualizan los metafields de la variante por defecto
      this.updateMetafields();
      this.updateProductTitle();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.applyVariantFilters();  // [filtrado por variante]
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateMetafields();
        this.updateProductTitle();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });

      // Se ejecuta el bloque de actualización de información sólo cuando ya hubo interacción del usuario
      if (this.hasUserChanged) {
        var final_variant_value = '';
        var variant_names = document.getElementsByClassName('m_titlee');
        const elements_hide = document.querySelectorAll('.custom_div');
        const textElement = document.querySelector('.dp-energy-efficiency-badge-rating-border');
        var variant_meta_values = document.getElementsByClassName('meta_value');
        if (this.currentVariant) {
          for (var i = 0; i < variant_names.length; i++) {
            if (variant_names[i].innerHTML.trim() == this.currentVariant.title.trim()) {
              final_variant_value = variant_meta_values[i].innerHTML;
            }
          }
        }
        // textElement solo existe en productos con badge de eficiencia energetica configurado;
        // en el resto es null y escribirle textContent directamente rompia el cambio de variante.
        if (textElement) {
          textElement.textContent = final_variant_value;
        }
        console.log(final_variant_value);
        elements_hide.forEach(element => {
          if (final_variant_value) {
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
        });
      } else {
        // Se marca que ya hubo una interacción para futuras actualizaciones
        this.hasUserChanged = true;
      }
    }

    updateMetafields() {
      if (typeof variantMetafields === 'undefined' || !this.currentVariant) return;

      const currentMetafield = variantMetafields.find(metafield => metafield.id == this.currentVariant.id);
      if (!currentMetafield) return;

      const heightContainer = document.querySelector('.variant_height');
      const heightSpan = document.querySelector('.height-text');
      const widthContainer = document.querySelector('.variant_width');
      const widthSpan = document.querySelector('.width-text');
      const lengthContainer = document.querySelector('.variant_length');
      const lengthSpan = document.querySelector('.length-text');

      if (heightContainer && heightSpan) {
        if (currentMetafield.height) {
          heightContainer.style.display = 'flex';
          heightSpan.innerText = currentMetafield.height;
        } else {
          heightContainer.style.display = 'none';
        }
      }

      if (widthContainer && widthSpan) {
        if (currentMetafield.width) {
          widthContainer.style.display = 'flex';
          widthSpan.innerText = currentMetafield.width;
        } else {
          widthContainer.style.display = 'none';
        }
      }

      if (lengthContainer && lengthSpan) {
        if (currentMetafield.length) {
          lengthContainer.style.display = 'flex';
          lengthSpan.innerText = currentMetafield.length;
        } else {
          lengthContainer.style.display = 'none';
        }
      }
    }

    updateProductTitle() {
      if (!this.currentVariant) return;

      const titleEl = document.getElementById(`ProductTitle-${this.dataset.section}`)
        || this.productWrapper?.querySelector('.product-title');
      const stickyTitleEl = document.querySelector('.product-add-to-cart-sticky--title');
      const titlesDataEl = document.getElementById(`VariantCustomTitles-${this.dataset.section}`);

      let customTitle = null;
      if (titlesDataEl) {
        try {
          const titles = JSON.parse(titlesDataEl.textContent);
          customTitle = titles[this.currentVariant.id];
        } catch (e) {
          customTitle = null;
        }
      }

      const defaultTitle = titleEl?.dataset.defaultTitle
        || stickyTitleEl?.dataset.defaultTitle
        || '';
      const displayTitle = (customTitle && String(customTitle).trim()) ? customTitle : defaultTitle;

      if (!displayTitle) return;

      if (titleEl) {
        titleEl.textContent = displayTitle;
      }
      if (stickyTitleEl) {
        stickyTitleEl.textContent = displayTitle;
      }

      const wishlistBtn = this.productWrapper?.querySelector('.wishlist-btn-product-page');
      if (wishlistBtn) {
        wishlistBtn.setAttribute('data-product-title', displayTitle);
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.option_keys.push(fieldset.querySelector('input').name);
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
      this.dataset.options = this.options;
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();     // [agrupación por imagen]
        this.other[0].applyVariantFilters();  // [filtrado por variante]
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();       // [agrupación por imagen]

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) {
          console.error("❌ Error: No se encontró el input[name='id']");
          return;
        }
        input.value = this.currentVariant ? this.currentVariant.id : "";
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `moq-notice-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      // this.dataset.url puede venir con query string propia (p. ej. ?view=quick-view
      // en el quick view), así que hay que encadenar con & en vez de asumir un ? fijo.
      const separator = this.dataset.url.indexOf('?') === -1 ? '?' : '&';
      fetch(`${this.dataset.url}${separator}variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');
            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');
          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        });
    }

    getOwnAddToCartButtons() {
      // Los botones pueden vivir dentro del <form> (botón principal) o fuera de
      // él vinculados via el atributo form="..." (barra sticky). Se filtran por
      // esta sección para no afectar a otros product-form presentes en la misma
      // página (p. ej. la ficha de producto detrás del quick view).
      const formId = `product-form-${this.dataset.section}`;
      return document.querySelectorAll(
        `#${formId} .single-add-to-cart-button, .single-add-to-cart-button[form="${formId}"]`
      );
    }

    toggleAddButton(disable = false, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const submitButtons = this.getOwnAddToCartButtons();
      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
        submitButton.classList.remove('sold-out');
        submitButtonText.textContent = window.theme.variantStrings.addToCart;
      });
    }

    setUnavailable() {
      const submitButtons = this.getOwnAddToCartButtons();
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();
      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          var isOne = false;
          const fieldset_options = Object.values(available_options)[i];
          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              let fieldset3 = Object.values(available_options)[2];
              if (fieldset3.length === 1) {
                isOne = true;
              }
              if (i === 1 && fieldset3.some(option => !option.isUnavailable) && isOne === true) {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              } else if (i === 1) {
                return;
              } else {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              }
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    /* ============================================================
       [FILTRADO POR VARIANTE — MÚLTIPLES CONDICIONES]
       ------------------------------------------------------------
       Sistema de filtrado por texto alternativo (alt) de la imagen.
       Es el sistema activo en sections/main-product.liquid.

       Formato del alt de cada imagen:
           loquesea#color_verde#tamaño_roll-8#cantidad_x1
       - Sin '#'  -> la imagen se muestra siempre (genérica).
       - Con '#'  -> solo se muestra si TODAS las condiciones coinciden.
       - Cada condición es  nombreOpcion_valor.

       Requiere el atributo data-variant-filter en cada slide.
       Métodos: getVariantOptionMap, matchesVariantFilter,
       applyVariantFilters. Reutiliza getImageSetName para normalizar.
       ============================================================ */

    getVariantOptionMap() {
      if (this._optionMap) return this._optionMap;
      const map = {};
      const inputs = this.querySelectorAll('.product-form__input');
      inputs.forEach((el, i) => {
        let handle = el.dataset.handle;
        let index = el.dataset.index;
        if (!handle) {
          const legend = el.querySelector('legend, .form__label, label');
          if (legend) handle = legend.textContent.split(':')[0].trim();
        }
        if (!index) index = 'option' + (i + 1);
        if (handle) map[this.getImageSetName(handle)] = index;
      });
      this._optionMap = map;
      return map;
    }

    matchesVariantFilter(filterString) {
      if (!filterString || filterString.indexOf('#') === -1) return true;

      const conditions = filterString.split('#').slice(1);
      const map = this.getVariantOptionMap();

      return conditions.every((condition) => {
        const sep = condition.indexOf('_');
        if (sep === -1) return true;

        const optionKey = this.getImageSetName(condition.slice(0, sep));
        const wanted = this.getImageSetName(condition.slice(sep + 1));
        const optionIndex = map[optionKey];
        if (!optionIndex) return false;

        const current = this.getImageSetName(this.currentVariant[optionIndex] || '');
        return current === wanted;
      });
    }

    applyVariantFilters() {
      if (!this.productSlider || !this.currentVariant) return;

      const slides = this.productSlider.querySelectorAll('[data-variant-filter]');
      if (!slides.length) return;

      let visible = 0;
      slides.forEach((slide) => {
        // El filtro por alt manda sobre todas las imágenes, incluida la destacada
        // de la variante: si una imagen está etiquetada para otra combinación, se
        // oculta aunque el admin la tenga como featured de esta variante.
        const hide = !this.matchesVariantFilter(slide.dataset.variantFilter);
        slide.classList.toggle('is-variant-hidden', hide);
        if (!hide) visible++;
      });

      // Red de seguridad: si ninguna imagen encaja, mostrarlas todas
      if (visible === 0) {
        slides.forEach((s) => s.classList.remove('is-variant-hidden'));
      }

      // Asignar el tamaño del grid SIN mover nada del DOM.
      //
      // El tema sube la imagen destacada de la variante al principio con prepend
      // (en updateMedia) cada vez que cambia la variante, y ese movimiento nunca se
      // revierte: es el comportamiento original y permanente del tema, no algo que
      // hayamos introducido nosotros. Por tanto el tamaño de cada foto se calcula
      // según el ORDEN REAL EN QUE EL DOM LAS TIENE en este momento (el que ha ido
      // dejando el prepend), y no según su número de orden original en la galería
      // (data-vf-order). Así, el tamaño coincide siempre con la posición que se ve
      // en pantalla, sin necesidad de reordenar el DOM: las 6 primeras visibles son
      // grandes, el resto pequeñas.
      let gridIndex = 0;
      slides.forEach((slide) => {
        if (slide.classList.contains('is-variant-hidden')) {
          slide.classList.remove('vf-grid-large', 'vf-grid-small');
          return;
        }
        slide.classList.toggle('vf-grid-large', gridIndex < 6);
        slide.classList.toggle('vf-grid-small', gridIndex >= 6);
        gridIndex++;
      });
    }

    /* ============ FIN — FILTRADO POR VARIANTE ============ */

    /* ============================================================
       [AGRUPACIÓN POR IMAGEN — MÉTODO DE UNA SOLA OPCIÓN]
       ------------------------------------------------------------
       Sistema de agrupación de imágenes por una única opción, basado
       en los atributos data-set-name / data-group de cada slide.
       Se mantiene disponible por si otra plantilla o galería (p.ej.
       quick-view) lo invoca. En sections/main-product.liquid está
       inactivo (sus atributos están comentados), por lo que aquí
       setImageSet no encuentra data-set-name y no realiza cambios.
       getImageSetName se comparte con el sistema de arriba.
       ============================================================ */

    setImageSet() {
      if (!this.productSlider) return;
      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;
          let entry = options[index].find(option => option.value === variant[index]);
          if (typeof entry === 'undefined') {
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, { value, index }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });
        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });
      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });
      this.setupProductGallery();
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
        items = this.buildItems(activeImages),
        captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };
      let openPswp = function (e, link, options, pswpElement, items) {
        let parent = link.closest('.product-images__slide');
        let i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement, items));
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');
      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');
      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({ left: this.slideScrollPosition });
    }
    updatePagination() {
      if (!this.nextButton) return;
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });
      this.handleErrorMessage();
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${theme.routes.cart_add_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        if (!parsedState.sections || !parsedState.sections[section.section]) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');
        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            }
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');
            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
                document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              }
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }
        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
    }
    setupToggle() {
      const toggleButton = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      // Solo configurar el toggle si existe (cuando hay variantes)
      if (!toggleButton || !content) return;

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            toggleButton.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            toggleButton.classList.remove('sticky-open');
          }
        });
        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');
        toggleButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          tl.reversed() ? tl.play() : tl.reverse();
          return false;
        });
      } else {
        toggleButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          content.classList.toggle('active');
          return false;
        });
      }
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer || entry.target === ngfContainer) {
              // Ocultar cuando cualquier parte del footer o ngf__container esté visible
              if (entry.isIntersecting || entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (!entry.isIntersecting && _this.formPassed && !_this.isFooterVisible) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();
              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                // Solo mostrar si el footer/ngf no está visible
                if (!_this.isFooterVisible) {
                  _this.classList.add('sticky--visible');
                }
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 0.1, 0.5, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer'),
        ngfContainer = document.querySelector('.ngf__container');

      _this.formPassed = false;
      _this.isFooterVisible = false;

      // Observer adicional para el footer Y ngf__container
      const footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          // Marcar como visible si cualquiera de los dos está intersectando
          if (entry.isIntersecting) {
            _this.isFooterVisible = true;
            _this.classList.remove('sticky--visible');
          } else {
            // Verificar si ambos están fuera de vista para volver a mostrar
            const footerRect = footer ? footer.getBoundingClientRect() : null;
            const ngfRect = ngfContainer ? ngfContainer.getBoundingClientRect() : null;
            const footerOutOfView = !footerRect || footerRect.top > window.innerHeight;
            const ngfOutOfView = !ngfRect || ngfRect.top > window.innerHeight;

            if (footerOutOfView && ngfOutOfView && _this.formPassed) {
              _this.isFooterVisible = false;
              _this.classList.add('sticky--visible');
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      });

      observer.observe(form);
      if (footer) {
        observer.observe(footer);
        footerObserver.observe(footer);
      }
      if (ngfContainer) {
        observer.observe(ngfContainer);
        footerObserver.observe(ngfContainer);
      }
    }
  }
  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }
  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

// Envolver en IIFE para evitar conflictos de scope.
// Deshabilita combinaciones de opciones inexistentes y auto-selecciona la
// primera combinación válida cuando la selección actual deja de existir
// (p. ej. al cambiar de color, se recoloca el tamaño a uno disponible para
// ese color en vez de dejar el producto en estado "no disponible").
(function () {
  'use strict';

  function initComboGuard(variantSelects) {
    if (!variantSelects || variantSelects.dataset.comboGuardInit === 'true') {
      return;
    }

    const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects';
    const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown'));
    const productJsonElement = variantSelects.querySelector('[type="application/json"]');
    if (!productJsonElement) {
      return;
    }

    let productJson;
    let selectedOptions = [];
    try {
      productJson = JSON.parse(productJsonElement.textContent);
    } catch (e) {
      // Silenciar errores de parsing
      return;
    }

    function validCombo(inputValue, optionLevel) {
      if (!productJson || !selectedOptions || !selectedOptions.length) {
        return false;
      }
      for (let i = 0; i < productJson.length; i++) {
        if (optionLevel == 1) {
          if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) { return true; }
        } else {
          if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) { return true; }
        }
      }
      return false;
    }

    function rebuildOptions() {
      selectedOptions = fieldsets.map((fieldset) => {
        return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
      });
      for (let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
        const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');
        inputs.forEach(input => {
          input.disabled = (validCombo(input.value, optionLevel)) ? false : true;
          if (pickerType == 'radios') {
            const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
            if (label) label.style.display = (input.disabled) ? "none" : "";
          } else {
            input.hidden = (validCombo(input.value, optionLevel)) ? false : true;
          }
        });
      }
      for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
        if (pickerType == 'radios') {
          const checkedInput = fieldsets[optionLevel].querySelector('input:checked');
          const nextValidInput = fieldsets[optionLevel].querySelector('input:not(:disabled)');
          if (checkedInput && checkedInput.disabled === true && nextValidInput) {
            change = (nextValidInput.checked = true);
          }
        } else {
          const checkedOption = fieldsets[optionLevel].querySelector('option:checked');
          const nextValidOption = fieldsets[optionLevel].querySelector('option:not(:disabled)');
          if (checkedOption && checkedOption.disabled === true && nextValidOption) {
            change = (nextValidOption.selected = "selected");
          }
        }
        if (change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    variantSelects.dataset.comboGuardInit = 'true';
    variantSelects.addEventListener('change', rebuildOptions);
    rebuildOptions();
  }

  // Página de producto: inicializar sobre cualquier variant-selects ya presente al cargar.
  document.querySelectorAll('variant-selects, variant-radios').forEach(initComboGuard);

  // Quick view: su <variant-selects> se inyecta más tarde vía AJAX, después de que
  // este script ya se ejecutó una vez, así que hay que enganchar el guard cuando se abre.
  document.addEventListener('quick-view:open', function () {
    initComboGuard(document.querySelector('#Product-Drawer variant-selects, #Product-Drawer variant-radios'));
  });
})(); // Cerrar IIFE


$(document).on("click", "quick-view", function () {
  const sidePanel = $(".side-panel-inner");
  sidePanel.css("position", "relative").append(`
        <div class="loader-overlay">
            <div class="loader"></div>
        </div>
    `);
  sidePanel.css("opacity", "0.5");
  setTimeout(() => {
    sidePanel.css("opacity", "1");
    sidePanel.find(".loader-overlay").remove();
  }, 2000);
});